import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Xetuyencodinh from "components/Xetuyencodinh/Xetuyencodinh.js";
export default function BCXetuyencodinh() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo tháng xe tuyến cố định",
            tabContent: <Xetuyencodinh />,
          },
        ]}
      />
    </div>
  );
}
